import { Tooltip, Typography } from "antd";
import React, { useState } from "react";
import styled from "styled-components";
const CompanyCard = (props) => {
  const { entity, companyName, mentions, hideMentions } = props;
  const [ellipsisState, setEllipsistate] = useState(false);
  const { Paragraph } = Typography;

  return (
    <CompanyCardStyle>
      <div className="wrapper padding-sm">
        {/* <p className="entity">{entity}</p> */}
        <div className="company-name">
          <Tooltip placement="top" title={ellipsisState ? companyName : undefined}>
            <Paragraph className="text-style" ellipsis={{ rows: 2, onEllipsis: setEllipsistate }}>
              <>{companyName}</>
            </Paragraph>
          </Tooltip>
          {/* <h4 className="company-name">{companyName}</h4> */}
        </div>
        {!hideMentions && <p className="mentions">{mentions} mentions</p>}
      </div>
    </CompanyCardStyle>
  );
};

CompanyCard.defaultProps = {
  entity: "Entity",
  companyName: "Company Name",
  mentions: 251,
};

const CompanyCardStyle = styled.div`
  .wrapper {
    width: 120px;
    margin: 5px;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    background-color: #001760;
    box-shadow: rgb(0 0 0 / 8%) 0px 4px 12px;
    height: 103px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      width: 90px;
      height: 75px;
      margin: 3px;
    }
    .entity {
      font-size: 9px;
      font-family: roboto_slabregular, serif;
      color: #ffffff;
      margin: 0;
      padding: 0;
      padding-left: 3px;
      position: absolute;
      top: 10px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 7px;
      }
    }
    .company-name {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-all;
      .text-style {
        color: #ffffff;
        margin: 0;
        text-align: center;
        font-size: 18px;
        font-family: Roboto, sans-serif;
        align-items: center;
        line-height: 1.2;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 13px;
        }
      }
    }
    .mentions {
      margin: 0;
      padding: 0;
      font-size: 10px;
      color: #ffffff;
      opacity: 0.75;
      text-align: center;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 8px;
      }
    }
  }
`;

export default CompanyCard;
